module.exports = __webpack_public_path__ + "static/media/joystick.a8c9b98c.svg";